import { useEffect, useMemo, useState } from "react";
import type { ProgressState } from "./curriculum";

const storageKey = "marble-curriculum-progress-v1";

export function useProgress() {
  const [progress, setProgress] = useState<Record<string, ProgressState>>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(progress));
  }, [progress]);

  return useMemo(
    () => ({
      progress,
      setTopicState(topicId: string, state: ProgressState) {
        setProgress((current) => ({
          ...current,
          [topicId]: state
        }));
      },
      resetProgress() {
        setProgress({});
      }
    }),
    [progress]
  );
}
